/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Timeline_ClosedInputs */



/**
* | output |
* | --- |
* | "Period closed" |
*
* @param {Receipt_Timeline_ClosedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_timeline_closed = /** @type {((inputs?: Receipt_Timeline_ClosedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Timeline_ClosedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitraum abgeschlossen")
	return /** @type {LocalizedString} */ ("Period closed")
});